declare namespace $ {

	type $mol_text_code__text_bog_vmap_app_history_snap_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_history_snap['preview'] >
		,
		ReturnType< $mol_text_code['text'] >
	>
	type $mol_text_code__Copy_bog_vmap_app_history_snap_2 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_text_code['Copy'] >
	>
	type $mol_labeler__label_bog_vmap_app_history_snap_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['label'] >
	>
	type $mol_labeler__content_bog_vmap_app_history_snap_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	export class $bog_vmap_app_history_snap extends $mol_button_minor {
		back( next?: any ): any
		Preview( ): $mol_text_code
		Sign( ): $mol_labeler
		moment( ): string
		author( ): string
		change( ): string
		preview( ): string
		editable( ): boolean
		enabled( ): ReturnType< $bog_vmap_app_history_snap['editable'] >
		hint( ): string
		click( next?: ReturnType< $bog_vmap_app_history_snap['back'] > ): ReturnType< $bog_vmap_app_history_snap['back'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=snap.view.tree.d.ts.map